import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { GADataService } from '@data-access';
import { provideGAHttpErrorInterceptor } from './ga-http-error-interceptor.provider';

export function provideGA(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideGAHttpErrorInterceptor(),
    provideAppInitializer(() => inject(GADataService).trackPageViews()),
  ]);
}
